/** @jsx jsx */
import { Flex } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { WizardSteps } from "./WizardSteps";

interface WizardProps {}

export const Wizard: FC<WizardProps> = ({ children }) => {
  return (
    <Flex flexDirection="column">
      <WizardSteps />

      <div>{children}</div>
    </Flex>
  );
};
